import { AlertCircle, ArrowRight } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"

interface PlanLimitBannerProps {
  feature: string
  limit: number
  current: number
}

export function PlanLimitBanner({ feature, limit, current }: PlanLimitBannerProps) {
  const navigate = useNavigate()
  return (
    <div className="flex items-center gap-3 p-3 rounded-xl bg-amber-50 border border-amber-200 text-sm">
      <AlertCircle className="h-4 w-4 text-amber-600 shrink-0" />
      <div className="flex-1 text-amber-800">
        You've reached your limit of {limit} {feature} on your current plan.
      </div>
      <Button
        size="sm"
        variant="outline"
        className="shrink-0 text-xs h-8"
        onClick={() => navigate("/pricing")}
      >
        Upgrade <ArrowRight className="h-3 w-3 ml-1" />
      </Button>
    </div>
  )
}
